<template>
  <div class="presentation-detail-google-slide-wrapper">
    <LoadingScreen v-if="!renderPresentationDetail" />
    <PresentationEditor
      v-if="currentUser.id"
      :isEnableEditPresentationWithOtherRouter="true"
      @callBackAfterLoadedPresentation="handleAfterLoadedPresentation"
    >
      <template #WarningParticipantLimit>
        <WarningParticipantLimit />
      </template>
      <template #EditorHeaderWrapper>
        <EditorHeaderGoogleSlide
          v-if="slideActive.activeTab === 1"
        />
        <EditorHeaderGoogleSlideEdit
          v-if="slideActive.activeTab === 2 || isSettingsContentVisible"
        />
      </template>
      <template #PublicAnnouncement>
        <PublicAnnouncement :z-index="150" />
      </template>

      <template #UserInactiveReloadModal v-if="showPopupUserInactive">
        <UserInactiveReloadModal />
      </template>
      <template #ContentEditPanel>
        <div class="w-full h-full">
          <GoogleSlideTutorial v-if="slideActive.activeTab === 1" />
          <RightPanelContainer
            :showingAudioTab="showingAudioTab"
            :defaultActiveTab="rightNavTabNames.CONTENT"
          />
          <GoogleSlideButtonEdit v-if="slideActive.activeTab === 1 && googleSlideActiveId" />
        </div>
      </template>
    </PresentationEditor>

    <SideBar v-if="currentUser.id" />
    <div
      class="backdrop"
      :class="{show: isSideBarBackDropVisible}"
      @click="hideMenuMobile"
    />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'

// components
import LoadingScreen from '@/components-v2/common/loading/LoadingScreen.vue'
import PresentationEditor from '@/components-v2/presentation-editor/PresentationEditor.vue'
import WarningParticipantLimit from '@/components/UI/WarningParticipantLimit.vue'
import EditorHeaderGoogleSlide from '@/components-v2/presentation-editor/editor-header/EditorHeaderGoogleSlide.vue'
import EditorHeaderGoogleSlideEdit from '@/components-v2/presentation-editor/editor-header/EditorHeaderGoogleSlideEdit.vue'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'
import UserInactiveReloadModal from '@/components-v2/presentation-editor/collaboration/UserInactiveReloadModal'
import RightPanelContainer from '@/components-v2/presentation-editor/side-right/right-nav/RightPanelContainer.vue'
import GoogleSlideTutorial from '@/components-v2/presentation-editor/side-right/GoogleSlideTutorial.vue'
import SideBar from '@/components-v2/common/sidebar/SideBar.vue'
import GoogleSlideButtonEdit from '@/components-v2/presentation-editor/side-right/GoogleSlideButtonEdit.vue'

export default {
  components: {
    LoadingScreen,
    PresentationEditor,
    WarningParticipantLimit,
    EditorHeaderGoogleSlide,
    PublicAnnouncement,
    UserInactiveReloadModal,
    RightPanelContainer,
    GoogleSlideTutorial,
    SideBar,
    GoogleSlideButtonEdit,
    EditorHeaderGoogleSlideEdit,
  },
  props: {
    timeShowPopupInactive: {
      type: Number,
      default: 1,
    },
    joinedAt: {
      type: Date,
      default: new Date(),
    },
    showPopupUserInactive: {
      type: Boolean,
      default: false,
    },
    isRightPanelContainerVisible: {
      type: Boolean,
      default: false,
    },
    showingAudioTab: {
      type: Boolean,
      default: false,
    },
    isSideBarBackDropVisible: {
      type: Boolean,
      default: false,
    },
    hideMenuMobile: {
      type: Function,
      default: () => {},
    },
    handleAfterLoadedPresentation: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      renderPresentationDetail: (state) => state.renderPresentationDetail,
      userInactiveReload: (state) => state.userInactiveReload,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      googleSlideActiveId: (state) => state.googleSlideActiveId,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapGetters('rightNav', ['rightNavTabNames']),
    ...mapGetters('rightPanelContainer', ['isSettingsContentVisible', 'isQuizTeamSetUpVisible']),
  },
}
</script>

<style lang="scss" scoped>
.presentation-detail-google-slide-wrapper {
  &::v-deep {
    .right-panel-container__wrapper, .panel-wrapper {
      width: 100%;
      height: 100%;
    }

    .right-presentation {
      width: 100%;
    }

    .right-panel-container {
      margin: 0 auto;
      height: 100%;
      border-radius: 0;
      width: 100%;
      border: none;
      box-shadow: none;
      padding-bottom: 60px;
    }
    .edit-panel-header {
      display: none;
    }
    .content-edit-panel__content {
      margin-top: 0;
      overflow: hidden;
    }
    .tab-content-presentation {
      padding: 8px 4px;
      padding-top: 16px;
    }

    .editor__background {
      display: block;
      background-color: #fff;
    }
    .right-column-settings .settings-content__wrapper.sub-content {
      margin-left: 1rem;
    }

    .slide-type-section__import {
      display: none;
    }

    .slide-type-list-section-content {
      display: none;
    }
    .slide-type-section-content {
      grid-template-columns: 1fr 1fr;
      gap: 8px;
    }
    .slide-type-list {
      padding-top: 0 !important;
    }
    .video-tutorial {
      display: none;
    }
    .settings-accordion {
      padding-top: 0;
    }
    .sidebar__item {
      display: none;

      &:last-child {
        display: block;
      }
    }

    .sidebar-resource, .team-managerment, .sidebar__title {
      display: none !important;
    }
    .border-b {
      border-bottom: 0;
    }

    .sidebar {
      .multiple-language-wrapper {
        position: unset;
        margin-bottom: 16px;;
      }
      .select-multiple-language {
        background-color: #fff;
        display: inline-flex;
        padding: 4px 10px;
        padding-left: 6px;
      }
      .mobile-display {
        display: none;
      }
    }

    .button-show-all {
      display: none;
    }

    .time-toggle-wrapper {
      input {
        padding-left: 4px;
        padding-right: 50px;
        width: 90px;
      }

      .unit-text {
        font-size: 11px;
      }

      .time-limit-content {
        margin-right: 6px !important;
      }

    }

    .beta-test, .smoke-test {
      display: none;
    }
  }
}
.backdrop {
  height: 100%;
  width: 100%;
  background-color: #00000060;
  position: fixed;
  z-index: 21;
  visibility: hidden;
  top: 0;
  opacity: 0;
  transition: .3s ease;
}
.backdrop.show {
  opacity: 1;
  visibility: visible !important;
}
</style>
